import { AppConfigModel } from "../../abstract/app-config.model";

export class BankStatementAutomation extends AppConfigModel {

    static override CLASS_NAME: string = 'BankStatementAutomation';
}
